import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EventWorldService } from './event-world.service';
import { EventWorldModel } from './EventWorldModel';
import { ImagesModel } from './ImagesModel';
import { SearchModel } from '../SearchModel';
import { CountriesModel } from '../CountriesModel';
import { CountriesService } from '../countries.service';
@Component({
    // moduleId: module.id,
    selector: 'events',
    templateUrl: 'events.component.html',
    styleUrls: ['events.component.scss']
})
export class EventsComponent implements OnInit {
  Menuoption = 'center';
  Settingicon = true
    projectDetails : any;
	projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
  declare lang: any;

    constructor( 
        public router: Router,
        private formBuilder : FormBuilder,
        private CountriesService:CountriesService,
        private modelService :EventWorldService,
        private route: ActivatedRoute,
        ) {      this.id = +route.snapshot.paramMap.get("id");
       }
       id=0;
       ngOnInit() {
        // this.lang = localStorage.getItem('theme_lang');
        debugger;
        this.modelService.getAll().subscribe(data=>{
            this.rows=data;
            console.log("modelObject",this.rows)
        })
        this.CountriesService.getAll().subscribe(data=>{
          this.CountriesList=data;
        })
        if(this.id > 0)
        {
          debugger;
          this.modelService.getById(this.id).subscribe(data=>{
            this.modelObject=data;
            this.files=this.modelObject.eventImagesList;
            this.files.forEach(element => {
              this.setImage(element.eventWorldId);
            });
            console.log("modelObject",this.rows)
            // this.mainForm = this.createForm(this.modelObject);

          })

        }
        else{
        //   this.mainForm = this.createForm(this.modelObject);                              
        }

        // this.GetAllCountries();
        // this.mainForm = this.createForm(this.modelObject); 
	}
    selectedIndex: number = 0;
	@Input()
	data:any;
    modelObject: EventWorldModel = new EventWorldModel();
	rows :EventWorldModel[]= [];

    mainForm: FormGroup = new FormGroup({
        id: new FormControl(),
        images: new FormControl(),
        titleAr: new FormControl(),
        titleEn: new FormControl(),
        titleFr: new FormControl(),
        descriptionAr: new FormControl(),
        descriptionEn: new FormControl(),
        descriptionFr: new FormControl(),
        latitude: new FormControl(),
        longitude: new FormControl(),
        countryId: new FormControl(),
        cityId: new FormControl(),
        userId: new FormControl(),
        date: new FormControl(),
    });
   
      files:ImagesModel[]=[];
     public picurl: string ='';
     editEnabled = true;
      setFileToList(){
        debugger;
          var file = new ImagesModel();
          file.eventWorldId = this.id ;
          file.imageURL = this.picurl;
          file.id = 0;
          this.picurl='';
          this.editEnabled = true;
          this.files.push(file);
      }
      goBack(){
        this.router.navigate(['/blimp/events']);
      }
  CountriesList :CountriesModel[]= [];
  selectedImages:ImagesModel={};
  SearchObject:SearchModel={};
  countryId=0;
  fromDate=new Date();
  toDate=new Date();
  Search(){
    debugger;
    this.SearchObject = new SearchModel();
    this.SearchObject.countryId = +this.countryId;
    this.SearchObject.fromDate = this.fromDate;
    this.SearchObject.toDate = this.toDate;
         this.modelService.GetAllByDate(this.SearchObject).subscribe(data=>{
           this.rows=data;
         })
     }


      setImage(EventId){
        debugger;
        var i = this.files.findIndex(x=>x.eventWorldId == this.id);
        if(i>-1){
          this.selectedImages = this.files[i];
        }
        else{
          this.selectedImages.imageURL=''
        }
        
      }
      EventDetails(id){
        this.router.navigate(['/events-Details/',id]);
        
      }
}
